import moment from 'moment-timezone';
import constants from 'Constants';


export function getShortcutPast7Days() {
  return {
    dateRange: [moment().subtract(6, 'days').toDate(), moment().toDate()],
    label: 'Past 7 Days'
  };
}

export function getShortcutPast30Days() {
  return {
    dateRange: [moment().subtract(29, 'days').toDate(), moment().toDate()],
    label: 'Past 30 Days'
  };
}

export function getShortcutThisMonth() {
  return {
    dateRange: [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
    label: 'This Month'
  };
}

export function getShortcutLastMonth() {
  return {
    dateRange: [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()],
    label: 'Last Month'
  };
}

export function getShortcutThisYear() {
  return {
    dateRange: [moment().startOf('year').toDate(), moment().endOf('year').toDate()],
    label: 'This Year'
  };
}

export function getShortcutAllTime() {
  return {
    dateRange: [null, null],
    label: 'All Time'
  };
}

export function getDateRangeLast7Days() {
  return {
    rangeType: constants.REPORT_RANGE_LAST_7_DAYS,
    startDate: moment().subtract(7, 'days'),
    endDate: moment().subtract(1, 'day'),
    label: 'Last 7 Days'
  };
}

export function getDateRangeLast14Days() {
  return {
    rangeType: constants.REPORT_RANGE_LAST_14_DAYS,
    startDate: moment().subtract(14, 'days'),
    endDate: moment().subtract(1, 'day'),
    label: 'Last 14 Days'
  };
}

export function getDateRangeLast30Days() {
  return {
    rangeType: constants.REPORT_RANGE_LAST_30_DAYS,
    startDate: moment().subtract(30, 'days'),
    endDate: moment().subtract(1, 'day'),
    label: 'Last 30 Days'
  };
}

export function getDateRangeLast60Days() {
  return {
    rangeType: constants.REPORT_RANGE_LAST_60_DAYS,
    startDate: moment().subtract(60, 'days'),
    endDate: moment().subtract(1, 'day'),
    label: 'Last 60 Days'
  };
}

export function getDateRangeLast90Days() {
  return {
    rangeType: constants.REPORT_RANGE_LAST_90_DAYS,
    startDate: moment().subtract(90, 'days'),
    endDate: moment().subtract(1, 'day'),
    label: 'Last 90 Days'
  };
}

export function getDateRangeThisYear() {
  return {
    rangeType: constants.REPORT_RANGE_THIS_YEAR,
    startDate: moment().startOf('year'),
    endDate: moment(),
    label: 'This Year'
  };
}

export function getDateRangeThisWeek() {
  return {
    rangeType: constants.REPORT_RANGE_THIS_WEEK,
    startDate: moment().startOf('isoWeek'),
    endDate: moment(),
    label: 'This Week'
  };
}

export function getDateRangeLastWeek() {
  return {
    rangeType: constants.REPORT_RANGE_LAST_WEEK,
    startDate: moment().subtract(1, 'weeks').startOf('isoWeek'),
    endDate: moment().startOf('isoWeek').subtract(1, 'day'),
    label: 'Last Week'
  };
}

export function getDateRangeThisMonth() {
  return {
    rangeType: constants.REPORT_RANGE_THIS_MONTH,
    startDate: moment().startOf('month'),
    endDate: moment(),
    label: 'This Month'
  };
}

export function getDateRangeLastMonth() {
  return {
    rangeType: constants.REPORT_RANGE_LAST_MONTH,
    startDate: moment().subtract(1, 'months').startOf('month'),
    endDate: moment().startOf('month').subtract(1, 'day'),
    label: 'Last Month'
  };
}

export function getDateRangeThisQuarter() {
  return {
    rangeType: constants.REPORT_RANGE_THIS_QUARTER,
    startDate: moment().startOf('quarter'),
    endDate: moment(),
    label: 'This Quarter'
  };
}

export function getDateRangeAllTime() {
  return {
    rangeType: constants.REPORT_RANGE_ALL_TIME,
    startDate: null,
    endDate: null,
    label: 'All Time'
  };
}

export function getPredefinedDateRanges() {
  return [
    getDateRangeLast7Days(),
    getDateRangeLast30Days(),
    getDateRangeThisMonth(),
    getDateRangeThisQuarter(),
    getDateRangeThisYear(),
    getDateRangeAllTime(),
  ]
}
